function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 30 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M10.454 24.42a3.47 3.47 0 01-2.627-1.202l-6.42-6.841A4.132 4.132 0 01.29 13.536c0-1.064.397-2.073 1.117-2.841 1.436-1.53 3.916-1.521 5.28.021l3.565 3.799c.095.102.353.102.451 0L22.912 1.5c1.438-1.531 3.917-1.518 5.28.023.703.75 1.111 1.814 1.098 2.899-.015 1.07-.42 2.06-1.138 2.783L13.107 23.241c-.714.76-1.656 1.179-2.653 1.179zM4.06 11.664c-.482 0-.936.202-1.28.569-.338.36-.524.823-.524 1.303s.186.941.524 1.301L9.22 21.7c.67.759 1.832.725 2.513.001L26.798 5.644c.339-.341.517-.78.525-1.253a1.926 1.926 0 00-.525-1.352c-.672-.757-1.833-.728-2.515 0l-12.21 13.015c-.841.892-2.355.892-3.193 0l-3.586-3.821a1.617 1.617 0 00-1.233-.569z",
  id: "ready-path"
})), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "ready",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ready-path"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#0F0F0F",
  fillRule: "nonzero",
  xlinkHref: "#ready-path"
}))));